import { useParams, useSearchParams } from 'react-router-dom';

import { AUTH_RETURN_URL } from '@constants/queryParams';

import { useAuthContext } from '../context';
import { ClientType } from '../types';
import { getBaseUrl } from '../utils';

// Only allow returning to this app's origin, to avoid an open redirect.
// Root-relative paths ("/foo") are resolved against the app's base URL.
const getSafeReturnUrl = (returnUrl: string | null) => {
  if (!returnUrl) return getBaseUrl();
  try {
    const url = new URL(
      returnUrl.startsWith('/') ? `${getBaseUrl()}${returnUrl}` : returnUrl
    );
    return url.origin === location.origin ? url.href : getBaseUrl();
  } catch {
    return getBaseUrl();
  }
};

const Login = () => {
  const { clients, activeClient } = useAuthContext();

  const { path } = useParams();
  const [searchParams] = useSearchParams();
  if (activeClient) {
    location.replace(getBaseUrl());
    return null;
  }

  switch (path) {
    case 'internal':
      if (!clients[ClientType.OktaInternal]) {
        throw new Error('Internal Okta client not available');
      }
      clients[ClientType.OktaInternal].login(getBaseUrl());
      break;
    case 'external': {
      if (!clients[ClientType.OktaExternal]) {
        throw new Error('External Okta client not available');
      }
      clients[ClientType.OktaExternal].login(
        getSafeReturnUrl(searchParams.get(AUTH_RETURN_URL))
      );
      break;
    }
    default:
      throw new Error('invalid path');
  }
  return null;
};

export { Login };
